import { render, staticRenderFns } from "./AppReposChart.vue?vue&type=template&id=01350484&scoped=true"
import script from "./AppReposChart.vue?vue&type=script&lang=ts"
export * from "./AppReposChart.vue?vue&type=script&lang=ts"
import style0 from "./AppReposChart.vue?vue&type=style&index=0&id=01350484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01350484",
  null
  
)

export default component.exports